import { accountApi } from '../../../redux/api/AccountApi';
import publicApi from '../../../redux/api/PublicApi';

interface LoginCredentials {
    uname: string,
    pwd: string,
    typeUsername: number,
}

interface LoginResponse {
    accessToken: string,
}

interface LoginOTPResponse {
    message: string,
    email: string,
}

interface LoginOTPCredentials {
    email: string,
    otp: string,
}

export const loginApi = accountApi.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation<LoginResponse, LoginCredentials>({
            query: (credentials) => ({
                url: 'login',
                method: 'POST',
                body: credentials
            }),
            transformResponse: (response: { body: LoginResponse }, meta, arg) => {
                return response.body;
            }
        }),

    })
})

export const loginOtpAPI = publicApi.injectEndpoints({
    endpoints: (builder) => ({
        loginOtp: builder.mutation<LoginOTPResponse, LoginCredentials>({
            query: (credentials) => ({
                url: 'login-otp',
                method: 'POST',
                body: credentials
            }),
            transformResponse: (response: { body: LoginOTPResponse }, meta, arg) => {
                return response.body;
            }

        }),
        verifyOtpLogin: builder.mutation<LoginResponse, LoginOTPCredentials>({
            query: (credentials) => ({
                url: 'verify-otp-login',
                method: 'POST',
                body: credentials
            }),
            transformResponse: (response: { body: LoginResponse }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const { useLoginMutation } = loginApi;
export const { useLoginOtpMutation, useVerifyOtpLoginMutation } = loginOtpAPI;